import React from 'react';
import { BoxIcon } from 'lucide-react';
interface MetricCardProps {
  title: string;
  value: string | number;
  change?: string | number;
  isPositive?: boolean;
  icon: BoxIcon;
  color?: string;
}
const MetricCard = ({
  title,
  value,
  change,
  isPositive = true,
  icon: Icon,
  color = 'bg-gray-100'
}: MetricCardProps) => {
  return <div className="rounded-lg border border-gray-200 bg-white p-6" data-id="element-959">
      <div className="flex items-center" data-id="element-960">
        <Icon className="h-5 w-5 mr-3 text-gray-700" data-id="element-961" />
        <div data-id="element-962">
          <p className="text-sm font-medium text-gray-500" data-id="element-963">{title}</p>
          <h3 className="mt-2 text-3xl font-bold text-gray-900" data-id="element-964">{value}</h3>
          {change && <div className="mt-1 flex items-center" data-id="element-965">
              <span className={`text-xs font-medium ${isPositive ? 'text-greenback' : 'text-red-600'}`} data-id="element-966">
                {isPositive ? '+' : ''}
                {change}
              </span>
              <span className="ml-1 text-xs text-gray-500" data-id="element-967">vs mese scorso</span>
            </div>}
        </div>
      </div>
    </div>;
};
export default MetricCard;